{
  "version": 1,
  "asset_id": "c94aa3f3-7b28-456a-8389-769bc6020ce3",
  "project_id": "81864b6f-53ca-42c2-811b-21ffcbfd0515",
  "url": "/__l5e/assets-v1/c94aa3f3-7b28-456a-8389-769bc6020ce3/villa-castellane.webp",
  "r2_key": "a/v1/81864b6f-53ca-42c2-811b-21ffcbfd0515/c94aa3f3-7b28-456a-8389-769bc6020ce3/villa-castellane.webp",
  "original_filename": "villa-castellane.webp",
  "size": 244118,
  "content_type": "image/webp",
  "created_at": "2026-07-13T07:04:02Z"
}
